import { DateTime } from 'luxon';
import * as IconSelector from '../icons';

const getCampañas = () => {
    const inicio = 2019;
    const fin = DateTime.now().year;
    let newEnum = [];

    for (let i = fin; i >= inicio; i--) {
        newEnum.push({
            value: i,
            label: i,
            description: 'Campaña',
            icon: IconSelector.CampañaIcon,
            color: 'black'
        });
    }

    return newEnum;
};

export const campañas = getCampañas();
